import React from "react";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import GPAP_Button from "../../../../../gpap-lib/Button_Collection";
import { GPAP_Button_Orange } from "../../../../../gpap-lib/Button_Collection";


const FootFrame =(props)=>{    
    return (
        <Stack direction="row" spacing={2}>
            <Typography variant={"h6"}> {"Selected " + props.selectedExperiments + "/" + props.totalExperiments} </Typography>


            <GPAP_Button onClick={props.completeSubmissionHandler}> 
                <i class="fa fa-table fa-lg" aria-hidden="true"/> COMPLETE SUBMISSION 
            </GPAP_Button>

            <GPAP_Button_Orange onClick={props.deleteExperimentsHandler}> 
                <i class="fa fa-trash-o fa-lg" aria-hidden="true"/> DELETE EXPERIMENTS 
            </GPAP_Button_Orange>

        </Stack>
    );
}

export default FootFrame;


